import React from "react";
import PropTypes from "prop-types";
import Card from "src/app/components/Card/Card";
import FaqList from "src/app/components/FaqList/FaqList";
import ErrorBox from "src/app/components/ErrorBox/ErrorBox";
import Hero from "src/app/components/Hero/Hero";

const FaqContent = ({ content = {}, faqItems = {}, storeData = {} }) => {
  const {
    analytics,
    main: { body: { elements = [] } = {} },
    metaData,
  } = content;

  let FaqContentWrapper;
  if (faqItems.error) {
    const {
      errorContent: [
        {
          searchApiErrorTitle = "Oops!",
          searchApiErrorDescription = "Sorry, this page isn’t available right now. In the meantime, why not take a look at another topic?",
        } = {},
      ] = [],
    } = elements[0];
    FaqContentWrapper = (
      <ErrorBox
        description={searchApiErrorDescription}
        header={searchApiErrorTitle}
        status={faqItems.error.status}
        statusText={faqItems.error.statusText}
        errorType="Search API"
      />
    );
  } else {
    FaqContentWrapper = (
      <>
        {elements[0]?.header && (
          <Hero
            text={elements[0].header.text}
            isCaps={elements[0].header.isCaps}
            mediumImage={elements[0]?.header["image-medium"]?.src || ""}
            largeImage={elements[0]?.header["image-large"]?.src || ""}
          />
        )}
        <FaqList
          items={faqItems.results}
          itemCount={faqItems.itemCount}
          currentPage={faqItems.currentPage}
          pageSize={faqItems.pageSize}
          start={faqItems.start}
          storeData={storeData}
          faqListCopy={elements.length && elements[0]["faq-list"]}
          analytics={analytics}
          faqID={analytics.itemId}
          baseUrl={metaData.baseUrl}
          errorContent={elements[0]?.clientErrorContent[0]}
        />
      </>
    );
  }

  return (
    <Card
      type="mainListingPage"
      ariaLive="polite"
      ariaRelevant="additions text"
    >
      {FaqContentWrapper}
    </Card>
  );
};

export default FaqContent;

FaqContent.propTypes = {
  content: PropTypes.object,
  storeData: PropTypes.object,
  faqItems: PropTypes.object,
};
